import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router'
import { canView } from '../../../utils/accountPermissionsUtils'

function AuthenticatedRoute({
  component,
  componentFunc,
  permissions,
  filter,
  disabled,
  ...restOfProps
}) {
  const state = useSelector(state => state)
  const isAuthenticated = useSelector(state => state.auth.isLoggedIn)
  const canViewRoute = useSelector(
    state =>
      canView(permissions, state.account?.permissions) &&
      (filter ? filter(state.profile?.userDetails) : true) &&
      (disabled ? !disabled(state.profile?.userDetails) : true)
  )

  // component can be a function (that returns component) or a component
  const Component = componentFunc ? componentFunc(state) : component

  return (
    <Route
      {...restOfProps}
      render={props =>
        isAuthenticated && canViewRoute && Component ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  )
}

export default AuthenticatedRoute
